import { Tabs } from "antd";
import i18n from "../../../../../utils/i18n";
import { useState } from "react";
import TestComponent from "../../../coming-soon/test-component";

const { TabPane } = Tabs;


const tabs = [
  {
    key: 1,
    name: i18n.t("BBALM.yields"),
    content: <TestComponent text={i18n.t("BBALM.yields")}/>,
  },
  {
    key: 2,
    name: i18n.t("BBALM.balances"),
    content: <TestComponent text={i18n.t("BBALM.balances")} />,
  },
  {
    key: 3,
    name: i18n.t("BBALM.interestIncome&Expenses"),
    content: <TestComponent text={i18n.t("BBALM.interestIncome&Expenses")} />,
  },
];

const VarianceAnalysis = () => {
    const [key, setKey] = useState("1");

  return (
    <div className="approval-workflow-wrapper">
      <Tabs
        defaultActiveKey={key}
        onChange={(activeKey) => {
            setKey(activeKey.toString())
        }}
      >
        {tabs.map((item) => (
          <TabPane tab={<>{item.name}</>} key={item.key}>
            {item.content}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default VarianceAnalysis;
